import {  Component, OnInit } from '@angular/core';
import { LoadingComponent } from '../shared/loading/loading.component';
import { AlertComponent, AlertModel, ALERT_TYPE } from '../shared/alert/alert.component';

import { SourceCodesService } from '../../services/sourcecodes/sourcecodes.service';
import { SourceCodesModel } from './models/models';

import { ɵAnimationGroupPlayer } from '@angular/animations';
import { Environment } from 'src/app/config/environment';
import { ReturnStatement } from '@angular/compiler';
import { Utils } from 'src/app/commons/utils';
import { SessionStorageService } from 'src/app/auth/services/session.service';
import { ExcelExportService } from 'src/app/services/excelExport/excel.export.service';
import { CommonDataService } from 'src/app/services/commons/commondata.service';
import { ProductosList } from 'src/app/models/lists.model';

@Component({
  selector: 'app-sourcecodes',
  templateUrl: './sourcecodes.component.html',
  styleUrls: ['./sourcecodes.component.css']
})
export class SourceCodesComponent implements OnInit {

  public title: string = "Administrador de Source Codes";
  public titleUser: string;
  public es: any;
  public showResult : boolean;
  public tablereports = null;
  public showNew : boolean; 
  public entityCurrent: SourceCodesModel = new SourceCodesModel;
  
  public loading: boolean;
  public alertMessage: AlertModel = new AlertModel;
  public alertConfirmEvent: Function;

  public validateShow: boolean =  false;
  public validateMessage: string;
  public isUpdate:boolean = false;
  public productosList :ProductosList = new ProductosList();

  public resultData = [];      // data que se muestra en la tabla (puede estar filtrada)
  public allData = [];         // copia completa de todos los sourcecodes, fuente para filtrar
  public subchannelList = [];
  public ngsubChannel : string = "";

  // Opciones de los desplegables del formulario de edición/nuevo
  public vendorsList: any[] = [];                       // {id: promotor, name: agencia/comercializadora}
  public canalList: string[] = [];                      // valores distintos de canal tomados de la tabla
  public tipoAplicacionList: string[] = ["PROSPECT"];
  public estadoList: string[] = ["ACTIVO", "INACTIVO"];

  // Filtros de la pantalla de búsqueda
  public searchFilter = {
    vigenteDesde: null,
    vigenteHasta: null,
    sourceCode: "",
    descripcion: "",
    agencia: "",
    producto: "",
    canal: "",
    estado: ""
  };
  public agenciaOptions: string[] = [];
  public productoOptions: string[] = [];
  public canalOptions: string[] = [];
  public estadoOptions: string[] = [];
  


  constructor(private sourcecodesService: SourceCodesService,
              private excelExportService: ExcelExportService,
              private commonDataService: CommonDataService,
              private sessionStorageService: SessionStorageService) { 
      
              this.sessionStorageService.rolValidate("config");
  }



  ngOnInit() {
    this.setCalendarLocale();
    this.loadProductos();
    this.loadResultData();   
    this.loadSubchannel();
    this.loadVendors();

  }

  // Carga la lista de vendors (promotor + agencia) para los desplegables del formulario
  loadVendors(){
    this.sourcecodesService.getVendorsList().subscribe(
      data => {
        if(data && data['data']){
          this.vendorsList = Object.assign([], data['data']);
        } else {
          console.log("No se encontraron vendors");
        }
      },
      error => {
        console.error("Error obteniendo los vendors", error);
      }
    );
  }

  // Al seleccionar un promotor, se guarda el promotor y se autocompleta la agencia
  promotorChange(value:string){
    this.entityCurrent.promotor = value;
    let vendor = this.vendorsList.find(v => ("" + (v.id ?? "")) == value);
    this.entityCurrent.comercializadora = vendor ? vendor.name : "";
  }

  // Al seleccionar una agencia, se guarda la agencia y se autocompleta el promotor
  agenciaChange(value:string){
    this.entityCurrent.comercializadora = value;
    let vendor = this.vendorsList.find(v => ("" + (v.name ?? "")) == value);
    this.entityCurrent.promotor = vendor ? vendor.id : "";
  }

  // El Source Code Completo se arma automáticamente como Canal + Source Code
  completeSourceCode(){
    let canal = this.entityCurrent.canal || "";
    let sc    = this.entityCurrent.source_code || "";
    this.entityCurrent.source_code_completo = canal + sc;
  }

  // Al editar un sourcecode cuyo promotor/agencia no está en la lista de vendors,
  // se agrega el par actual para que el valor existente quede seleccionado en el combo.
  private ensureVendorOption(){
    let promotor = this.entityCurrent.promotor;
    let agencia  = this.entityCurrent.comercializadora;

    if(Utils.isNullOrEmpty(promotor) && Utils.isNullOrEmpty(agencia))
      return;

    let exists = this.vendorsList.some(v => ("" + (v.id ?? "")) == ("" + (promotor ?? ""))
                                         && ("" + (v.name ?? "")) == ("" + (agencia ?? "")));
    if(!exists){
      this.vendorsList = [{ id: promotor, name: agencia }, ...this.vendorsList];
    }
  }

  loadResultData(){
    
    this.loading = true;

    this.sourcecodesService.getData().subscribe(
      data => {
        if (data['data']) {
          this.allData = data['data'];
          this.resultData = this.allData;
          this.buildFilterOptions();

          this.setupTable();

        }
        else {
          this.loading = false;
          this.showResult = true;
          console.error(data);
          this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.",this.title,true);
        }

      },
      error => {
        this.loading = false;
        this.showResult = true;
        console.error(error);
        this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.",this.title,true);
      }
    );

  }

  onConfirmEvent(confirm:any){

    if(confirm.confirm){
      this.delete();
    }else{
      this.entityCurrent = null;
    }
  }

  delete(){
      this.loading = true;

      let request = {
        "source_code_completo" : this.entityCurrent.source_code_completo
      };


      this.sourcecodesService.delete(request).subscribe(
        data => {
          if (data && data["code"] && data["code"] == "0") {
            
            this.loading = false;
            this.entityCurrent = new SourceCodesModel();
            this.alertMessage = new AlertModel("Los datos se guardaron con exito",this.title,true);
            this.loadResultData();
          }
          else {
            this.loading = false;
            console.error(data);
            this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.",this.title,true);
          }
          
        },
        error => {
          this.loading = false;
          console.error(error);
          this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.",this.title,true);
        }
      );    




  }

  deleteConfirm(source_code_completo){    
    this.entityCurrent =  new SourceCodesModel();
    this.entityCurrent.source_code_completo = source_code_completo;
    this.alertConfirmEvent = this.onConfirmEvent;

    this.alertMessage = new AlertModel("Está seguro de eliminar este Sourcecode?",this.title,true, "CONFIRM");
  }

  new(id){
    
    this.entityCurrent = new SourceCodesModel();
    this.showNew = true;
    this.showResult = false;

    if(id == null){
      this.titleUser = "Nuevo Sourcecode";
      this.entityCurrent.created_user = this.sessionStorageService.getCurrentUser().name;
      this.entityCurrent.created_timestamp = new Date().getTime().toString();
      this.entityCurrent.last_updated = new Date().getTime().toString();

    } else{
      this.isUpdate = true;
      this.titleUser = "Modificar Sourcecode";
      this.entityCurrent = Object.assign({}, this.allData.find(m => { return m.id == id}));
      this.entityCurrent.last_updated = new Date().getTime().toString();
      this.prodChange(this.entityCurrent.prod);
      this.ngsubChannel = this.entityCurrent.subchannel;
      this.ensureVendorOption();
      // El estado en la DB puede venir como Activo/ACTIVO/Inactivo/INACTIVO.
      // Se normaliza a mayúsculas para que coincida con las opciones del desplegable.
      this.entityCurrent.estado = (this.entityCurrent.estado || "").toUpperCase();
    }

    this.validateShow  =  false;
    this.validateMessage = "";

  }
 
  newCancel(){
    this.isUpdate = false;
    this.showResult = true;
    this.showNew = false;
    this.ngsubChannel = "";
  }

  newSave(){   

    if(this.entityCurrent.id == null){
      this.newCreate();
    } else{
      this.newUpdate();
    }
  }


  newCreate(){    
    
    if(this.verificationDates(this.entityCurrent.initial_effective_date)>this.verificationDates(this.entityCurrent.final_effective_date)){
      this.alertMessage = new AlertModel("La fecha final no puede ser menor que la inicial.",this.title,true);
      this.loading = false;    
      return;
    }

    if(this.allData.some( c=>c.source_code_completo ==this.entityCurrent.source_code_completo )){
      this.alertMessage = new AlertModel("El Source Code que se intenta crear ya existe.",this.title,true);
      this.loading = false;    
      return;
    }

    if(this.allData.some( c=>c.promotor ==this.entityCurrent.promotor && c.prod ==this.entityCurrent.prod 
      && this.verificationDates(c.initial_effective_date) <=this.verificationDates(this.entityCurrent.final_effective_date)
      && this.verificationDates(c.final_effective_date) >=this.verificationDates(this.entityCurrent.initial_effective_date) 
      && c.subchannel == this.entityCurrent.subchannel)){

      this.alertMessage = new AlertModel("El Promotor, producto, sub canal y fechas vigencias estan contenidos en otro sourcecode",this.title,true);
      this.loading = false;    
      return;
    }
    this.entityCurrent.subchannel = this.ngsubChannel;
    if(!this.newValidate())
        return;       

    
    this.loading = true;

    this.sourcecodesService.create(this.entityCurrent).subscribe(
      data => {

        if (data && data["code"] && data["code"] == "0") {
          this.showNew = false; 

          this.entityCurrent=  new SourceCodesModel();
          this.alertMessage = new AlertModel("Los datos se guardaron con exito",this.title,true);
          this.loadResultData();
        }
        else if (data && data["code"] && data["code"] == "100") {
          
          this.alertMessage = new AlertModel("Hubo un inconveniente: " + data["message"],this.title,true);
          this.loading = false;    
          return;      
        } else{
          this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.",this.title,true);
          this.loading = false;   
        }

      },
      error => {
        console.error(error);
        this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.",this.title,true);
        this.loading = false; 
      }
    );
    
    
  }

  verificationDates(dato){
    const[day,month,year]=dato.split("/")
    const date= new Date(year,month-1,day);
    return date
  }
  newUpdate(){      

        
    if(this.verificationDates(this.entityCurrent.initial_effective_date)>this.verificationDates(this.entityCurrent.final_effective_date)){
      this.alertMessage = new AlertModel("La fecha final no puede ser menor que la inicial.",this.title,true);
      this.loading = false;    
      return;
    }

    if(this.allData.some( c=>c.id !=this.entityCurrent.id && c.promotor ==this.entityCurrent.promotor && c.prod ==this.entityCurrent.prod 
      && this.verificationDates(c.initial_effective_date) <=this.verificationDates(this.entityCurrent.final_effective_date)
      && this.verificationDates(c.final_effective_date) >=this.verificationDates(this.entityCurrent.initial_effective_date) 
      && c.subchannel == this.entityCurrent.subchannel)){

      this.alertMessage = new AlertModel("El Promotor, producto, Subchannel y fechas vigencias estan contenidos en otro sourcecode",this.title,true);
      this.loading = false;    
      return;
    }

    this.entityCurrent.subchannel = this.ngsubChannel;
    if(!this.newValidate())
        return;        

    
    this.loading = true;

    this.sourcecodesService.update(this.entityCurrent).subscribe(
      data => {

        if (data && data["code"] && data["code"] == "0") {
          this.showNew = false;      
          this.isUpdate = false;

          this.entityCurrent=  new SourceCodesModel();
          this.alertMessage = new AlertModel("Los datos se guardaron con exito",this.title,true);
          this.loadResultData();
        }
        else if (data && data["code"] && data["code"] == "100") {
          
          this.alertMessage = new AlertModel("Hubo un inconveniente: " + data["message"],this.title,true);
          this.loading = false;    
          return;      
        } else{
          this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.",this.title,true);
          this.loading = false;   
        }

        

      },
      error => {
        console.error(error);
        this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.",this.title,true);
        this.loading = false; 
        this.isUpdate = false;
      }
    );
    
    
  }  


  newValidate():boolean{

    let validations = "";
    


    if(Utils.isNullOrEmpty(this.entityCurrent.tipo_aplicacion))
      validations+="Debe completar el campo tipo_aplicacion. "


    if(Utils.isNullOrEmpty(this.entityCurrent.canal))
        validations+="Debe completar el campo canal. "

    if(Utils.isNullOrEmpty(this.entityCurrent.descripcion))
        validations+="Debe completar el campo descripcion. "

    if(Utils.isNullOrEmpty(this.entityCurrent.sid))
        validations+="Debe completar el campo sid."        


    if(Utils.isNullOrEmpty(this.entityCurrent.estado))
      validations+="Debe completar el campo estado."           


    if(Utils.isNullOrEmpty(this.entityCurrent.comercializadora))
      validations+="Debe completar el campo Agencia."    


    if(Utils.isNullOrEmpty(this.entityCurrent.promotor))
      validations+="Debe completar el campo promotor."        

    if(Utils.isNullOrEmpty(this.entityCurrent.ciclo))
      validations+="Debe completar el campo ciclo."     

      
    if(Utils.isNullOrEmpty(this.entityCurrent.source_code))
      validations+="Debe completar el campo Source Code."    

      
    if(Utils.isNullOrEmpty(this.entityCurrent.source_code_completo))
      validations+="Debe completar el campo Source Code Completo."  


    if(Utils.isNullOrEmpty(this.entityCurrent.ingreso))
     validations+="Debe completar el campo ingreso."

    if(Utils.isNullOrEmpty(this.entityCurrent.prod_mns))
      validations+="Debe completar el campo Prod MNS."

    if(Utils.isNullOrEmpty(this.entityCurrent.prod_name))
      validations+="Debe completar el campo Prod Name."

    if(Utils.isNullOrEmpty(this.entityCurrent.delivery_2))
      validations+="Debe completar el campo Delivery 2."

    if(Utils.isNullOrEmpty(this.entityCurrent.delivery_1))
      validations+="Debe completar el campo Delivery 1."      

      if(Utils.isNullOrEmpty(this.entityCurrent.delivery_1))
      validations+="Debe completar el campo Delivery 1."  

      if(Utils.isNullOrEmpty(this.entityCurrent.subchannel))
      validations+="Debe completar el campo Subchannel."  

      

    if(validations != "") {
        this.validateShow  =  true;
        this.validateMessage = validations;

        return false;
      }

    this.validateShow  =  false;
    this.validateMessage = "";
    return true;
  }

  backToResults(){
    this.showResult = true;
    this.loading = false;

  }

  setDateFormat(value:Date){

     return Utils.setDateFormat(value);
  }

  upload(event){
        
    let fileList: FileList = event.target.files;

    if(fileList.length == 0) {      
      this.alertMessage = new AlertModel("Seleccione solo un archivo.", this.title, true, ALERT_TYPE.WARNING);
      return;
    }

    let file: File = fileList[0];


    var extension = file.name.split(".").pop().toLowerCase();
    var extensiones = ["txt"];
   
    if(extensiones.indexOf(extension) === -1){
      this.alertMessage = new AlertModel("Seleccione un archivo con extención .txt ", this.title, true, ALERT_TYPE.WARNING);
      return;
   }else{
      this.loading = true;
 
      this.sourcecodesService.import(file).subscribe(
        data => {
          if (data['code']== 0) {
            
            this.loadResultData();
            this.alertMessage = new AlertModel("La carga se procesó con exito: " + data['message'], this.title, true, ALERT_TYPE.SUCCESS);
          }
          else {
            let message  = !Utils.isNullOrEmpty(data['message']) ? "Hubo un inconveniente: " + data['message'] :"Hubo un inconveniente al obtener la información, inténtalo nuevamente.";
            this.alertMessage = new AlertModel(message, this.title, true, ALERT_TYPE.WARNING);
            this.loading = false;
          }
          
        },
        error => {
          console.error(error);
          this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.", this.title, true, ALERT_TYPE.ERROR);
          this.loading = false;
        }
      );   


    }

    $("#importFile").val('');
  }


  export(){

    let reportDataExport = new Array<any>();

    this.resultData.forEach(item => {      
      reportDataExport.push({
        "Agencia":item.comercializadora,
        "Canal":item.canal,
        "Subchannel":item.subchannel,
        "Ciclo":item.ciclo ,
        "Delivery 1 ":item.delivery_1,
        "Delivery 2":item.delivery_2,
        "Descripción":item.descripcion,
        "Estado":item.estado,
        "Ingreso ":item.ingreso,
        "Nro. Promotor":item.promotor,
        "Prod MNS":item.prod_mns,
        "Prod Name ":item.prod_name ,
        "Producto":item.prod,
        "SID":item.sid,
        "Source Code":item.source_code,
        "Source Code Completo":item.source_code_completo,
        "Tipo Aplicación":item.tipo_aplicacion,    
        "Created Timestamp": Utils.dateTimeStamp(item.created_timestamp),     
        "Created User":item.created_user,     
        "Last Updated": Utils.dateTimeStamp(item.last_updated),
        "Fecha vigencia inicial": item.initial_effective_date,
        "Fecha vigencia final": item.final_effective_date   
              
      });
    }); 

    this.excelExportService.exportAsExcelFile(reportDataExport, this.title);

  }
  
  prodChange(value:string){

    console.log("entra a prodChange");
    let prod = this.productosList.data.find(p=> (p.data?.prod??"") == value);

    console.log("filtra a prodChange");
    if(prod && prod.data){
      this.entityCurrent.prod = prod.data.prod;
      this.entityCurrent.prod_name = prod.data.prodName;
      this.entityCurrent.prod_mns = prod.data.prodMns;
      this.entityCurrent.ingreso = prod.data.income;
    }

  }


  loadProductos(){

    Utils.storageSave("productos-data", null);

    this.commonDataService.getProductos().subscribe(
      data => {
        if (data['code'] == "0" && data['data']) {          
          this.productosList.data = Object.assign([], data['data']);
        }
        else {
          console.error(data);
        }

        this.loading = false;
      },
      error => {
        console.error(error);
      }
    );

    
    

  }

  private setupTable(){

    this.showResult = true;
    this.loading = false;

    if (this.tablereports != null) {
      this.tablereports.clear().destroy();
      this.tablereports = null;
    }

    // Se espera a que Angular haya renderizado las filas del *ngFor en el DOM
    // antes de inicializar DataTable. Al filtrar en memoria el repintado de
    // Angular ocurre en un tick posterior, por eso no alcanza con setTimeout(0).
    this.initDataTableWhenReady(0);
  }

  // Inicializa el DataTable sólo cuando el <tbody> ya tiene las filas esperadas.
  private initDataTableWhenReady(attempt:number){
    let domRows = $("#result-table tbody tr").length;
    let expected = (this.resultData || []).length;

    // Si todavía no se pintaron todas las filas (y hay filas esperadas), reintentar.
    if (expected > 0 && domRows < expected && attempt < 20) {
      setTimeout(() => this.initDataTableWhenReady(attempt + 1), 20);
      return;
    }

    this.tablereports = $("#result-table").DataTable({
      searching: true,
      paging: true,
      lengthChange: false,
      pageLength: 10,
      pagingType: 'full_numbers',
      columnDefs: [
        { targets: 'no-sort', orderable: false },
        { width: "70px", targets: 6 }
      ],
      language: Environment.DataTableLanguageSetting
    });
  }  

  setCalendarLocale(){

    this.es = Environment.CalendarLanguageSetting;
  }

  castDateShort(date){
    return Utils.isNullOrEmpty(Utils.dateTimeStamp(date)) ? date : Utils.dateTimeStamp(date);
  }

  castDateShortInitial(date){
    const fecha=new Date();
    fecha.setMonth(fecha.getMonth()-4);
    const fechaString=fecha.toLocaleDateString('es-ES')
    if(date==null){
      this.entityCurrent.initial_effective_date=fechaString
    }
    return Utils.isNullOrEmpty(date) ? fechaString : date;
  }
  

  castDateShortFinal(date){
    const fecha=new Date();
    fecha.setMonth(fecha.getMonth()+4);
    const fechaString=fecha.toLocaleDateString('es-ES')
    if(date==null){
      this.entityCurrent.final_effective_date=fechaString
    }
    return Utils.isNullOrEmpty(date) ? fechaString : date;
  }

  getTimesTamp(dateString:string):string{ //le paso una fecha en formato DD/MM/YYYY
  var finalString = "";
  if( dateString != null ){
    var arrayString = dateString.split( "/" );
    var dateToParse = arrayString[2] + "-" + arrayString[1] + "-" + arrayString[0] + " 00:00:00";
  
    finalString = new Date( dateToParse ).getTime().toString();
  }
  return finalString;
}

  loadSubchannel(){
    this.sourcecodesService.getSubchannel().subscribe(
      response => {

        if( response.status == 200 && response.body != null){

          this.subchannelList = Object.assign([], response.body);

        }else if( response.status == 204 ){
          console.log( "no se encontraron subChannels" );
        }else{
          console.log( "Error 1 obteniendo los subChannel" );
        }

      }, err => {
        console.log( "Error 2 obteniendo los subChannel" );
        this.loading = false;
        throw err;
      }
    );
  }


  // ----- Pantalla de búsqueda -----

  // Arma las opciones de los desplegables a partir de los valores distintos de la data
  buildFilterOptions(){
    this.agenciaOptions  = this.distinctValues(this.allData, "comercializadora");
    this.productoOptions = this.distinctValues(this.allData, "prod");
    this.canalOptions    = this.distinctValues(this.allData, "canal");
    // El estado se unifica a mayúsculas para que "Activo"/"ACTIVO" (e "Inactivo"/"INACTIVO") sean una sola opción
    this.estadoOptions   = this.distinctValues(this.allData, "estado", true);

    // El desplegable de Canal del formulario toma los valores distintos de la tabla
    this.canalList = this.distinctValues(this.allData, "canal");
  }

  private distinctValues(data:any[], field:string, upper:boolean = false):string[]{
    let set = new Set<string>();
    (data || []).forEach(item => {
      let value = item[field];
      if(!Utils.isNullOrEmpty(value)){
        let normalized = ("" + value).trim();
        if(upper){ normalized = normalized.toUpperCase(); }
        set.add(normalized);
      }
    });
    return Array.from(set).sort((a, b)=> a.localeCompare(b));
  }

  // Aplica los filtros sobre resultData y reconstruye la tabla
  search(){
    let desde = this.parseDate(this.searchFilter.vigenteDesde);
    let hasta = this.parseDate(this.searchFilter.vigenteHasta);

    if(desde && hasta && desde.getTime() > hasta.getTime()){
      this.alertMessage = new AlertModel("La fecha 'Vigente desde' no puede ser mayor que 'Vigente hasta'.", this.title, true);
      return;
    }

    this.rebuildTableWith(() => this.applyFilter());
  }

  clearSearch(){
    this.searchFilter = {
      vigenteDesde: null,
      vigenteHasta: null,
      sourceCode: "",
      descripcion: "",
      agencia: "",
      producto: "",
      canal: "",
      estado: ""
    };
    this.rebuildTableWith(() => this.applyFilter());
  }

  // Destruye el DataTable, vacía la tabla para que Angular borre las filas viejas,
  // aplica el filtro (callback) y reconstruye el DataTable una vez que el *ngFor
  // repintó las nuevas filas. Esto evita el conflicto DataTable <-> *ngFor.
  private rebuildTableWith(applyFn: () => void){
    // 1) Destruir el DataTable actual (libera el control del <tbody>).
    if (this.tablereports != null) {
      this.tablereports.destroy();
      this.tablereports = null;
    }
    // 2) Vaciar la tabla para forzar a Angular a remover las filas renderizadas.
    this.resultData = [];
    // 3) En el próximo tick, aplicar el filtro (nuevo array) y reconstruir.
    setTimeout(() => {
      applyFn();
      this.setupTable();
    }, 0);
  }

  applyFilter(){
    let desde = this.parseDate(this.searchFilter.vigenteDesde);
    let hasta = this.parseDate(this.searchFilter.vigenteHasta);
    if(desde){ desde.setHours(0,0,0,0); }
    if(hasta){ hasta.setHours(23,59,59,999); }

    let sourceCode  = (this.searchFilter.sourceCode  || "").trim().toLowerCase();
    let descripcion = (this.searchFilter.descripcion || "").trim().toLowerCase();

    this.resultData = (this.allData || []).filter(item => {

      if(sourceCode && !("" + (item.source_code_completo || "")).toLowerCase().includes(sourceCode)
                    && !("" + (item.source_code || "")).toLowerCase().includes(sourceCode))
        return false;

      if(descripcion && !("" + (item.descripcion || "")).toLowerCase().includes(descripcion))
        return false;

      if(this.searchFilter.agencia && ("" + (item.comercializadora || "")).trim() != this.searchFilter.agencia)
        return false;

      if(this.searchFilter.producto && ("" + (item.prod || "")).trim() != this.searchFilter.producto)
        return false;

      if(this.searchFilter.canal && ("" + (item.canal || "")).trim() != this.searchFilter.canal)
        return false;

      if(this.searchFilter.estado && ("" + (item.estado || "")).trim().toUpperCase() != this.searchFilter.estado.toUpperCase())
        return false;

      // Rango de vigencia: el período de vigencia del sourcecode debe cruzarse
      // con el rango buscado (desde/hasta).
      if(desde || hasta){
        let ini = this.parseDate(item.initial_effective_date);
        let fin = this.parseDate(item.final_effective_date);

        if(hasta && ini && ini.getTime() > hasta.getTime())
          return false;

        if(desde && fin && fin.getTime() < desde.getTime())
          return false;
      }

      return true;
    });
  }

  // Convierte una fecha a Date. Acepta un Date o un string dd/MM/yyyy. Null/vacío -> null (no filtra).
  private parseDate(value:any):Date{
    if(Utils.isNullOrEmpty(value)) return null;
    if(value instanceof Date) return new Date(value.getTime());
    let parts = ("" + value).split("/");
    if(parts.length != 3) return null;
    let day = parseInt(parts[0], 10);
    let month = parseInt(parts[1], 10);
    let year = parseInt(parts[2], 10);
    if(isNaN(day) || isNaN(month) || isNaN(year)) return null;
    return new Date(year, month - 1, day);
  }

}

